import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import {Form, Formik, getIn, isEmptyArray} from 'formik'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import RateplansService from 'services/RateplansService'
import RoomTypesService from 'services/RoomTypesService'
import {isArrayNotEmpty, isCompletedHotelInfoHistory, isFlagCompleted} from 'utilities/JSUtil'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import TextInput from '../../../atoms/form/TextInput/TextInput'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './SRPInventory.scss'
import SRPInventoryService from "../../../../services/SRPInventoryService";

class SRPInventory extends Component {

    constructor(props) {
        super(props)
        this.handleSubmit = this.handleSubmit.bind(this)
        let hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        let hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
        const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY)

        if (!hotelCode) {
            // Go home
            this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
        }

        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            initialValues: this.initialValues,
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            showResetModal: false,
            showErrorModal: false,
            hotelInfoCompletedHistory: hotelInfoCompletedHistory,
            roomTypes: []
        }
    }

    initialValues = {
        srpInventory: []
    }


    validationSchema = Yup.object().shape({
        srpInventory: Yup.array().of(
            Yup.object().shape({
                participating: Yup.boolean().required(FormConst.VALIDATION_ERROR_REQUIRED),
                inventory: Yup.number().when('participating', {
                    is: true,
                    then: Yup.number()
                        .required(FormConst.VALIDATION_ERROR_REQUIRED)
                        .typeError('Please enter numbers')
                        .integer('Please enter whole numbers')
                        .min(2, 'Minimum 2 required'),
                    otherwise: Yup.number().notRequired()
                }),
                roomTypes: Yup.array().of(
                    Yup.object().shape({
                        code: Yup.string(),
                        isChecked: Yup.boolean()
                    })
                ).when('participating', {
                    is: true,
                    then: Yup.array().test(
                        'at-least-one-selected',
                        'At least one room type must be selected',
                        function(roomTypes) {
                            return roomTypes && roomTypes.some(rt => rt.isChecked === true)
                        }
                    ),
                    otherwise: Yup.array().notRequired()
                })
            })
        )
    })

    async componentDidMount() {
        // Get srpInventory from history or service
        const isSectionCompleted = isFlagCompleted('SRP_INVENTORY', this.props.checklist)
        let srpInventoriesFromHistory = this.state.hotelInfoCompletedHistory?.srpInventories?.srpInventories;
        let roomTypes = [];

        if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory) && srpInventoriesFromHistory) {
            roomTypes = this.state.hotelInfoCompletedHistory.newEntity?.hotelRoomTypes?.roomTypes;
            await this.buildFormValues(roomTypes, srpInventoriesFromHistory);
        } else {
            await RoomTypesService.getRoomTypes({ hotelCode: this.state.hotelCode })
                .then(async response => {
                    if (isArrayNotEmpty(response.roomTypes)) {
                        roomTypes = response.roomTypes
                    } else {
                        this.setState({
                                          isLoading: false,
                                          showErrorModal: true,
                                          errorMessage: 'No room types found'
                                      })
                    }
                })

            // Now get the SRP rate plans
            await RateplansService.getStandardRateplans({ hotelCode: this.state.hotelCode })
                .then(async response => {
                    let ratePlans = response.ratePlans.map(rateplan => ({
                        ratePlanCode: rateplan.ratePlanCode,
                        ratePlanName: rateplan.ratePlanName,
                        inventory: rateplan.dailyRoomCount,
                        participating: rateplan.useRatePlanInventory
                    }))

                    let srpInventoryResponse = {}
                    // Read the existing SRP inventory from service
                    await SRPInventoryService.getSrpInventory({ hotelCode: this.state.hotelCode })
                        .then(response => {
                            srpInventoryResponse = response
                        }).catch(() => {
                            this.setState({
                                              isLoading: false,
                                              showErrorModal: true,
                                              errorMessage: 'There was an error while reading room types data'
                                          })
                        })

                    // Merge srpInventoryResponse.srpInventories into ratePlans
                    if(srpInventoryResponse && srpInventoryResponse.srpInventories && isArrayNotEmpty(srpInventoryResponse.srpInventories)) {
                        // Create a map of srpInventories by ratePlanCode for quick lookup
                        const srpInventoryMap = new Map(
                            srpInventoryResponse.srpInventories.map(item => [item.ratePlanCode, item])
                        )

                        // Merge: replace ratePlan with srpInventory if ratePlanCode matches
                        ratePlans = ratePlans.map(ratePlan => {
                            const srpInventory = srpInventoryMap.get(ratePlan.ratePlanCode)
                            return srpInventory ? { ...ratePlan, ...srpInventory } : ratePlan
                        })

                    } else if (isSectionCompleted && isEmptyArray(srpInventoryResponse.srpInventories)) {
                        ratePlans = ratePlans.map(ratePlan => {
                            ratePlan.participating = false
                            return ratePlan
                        })
                    }

                    await this.buildFormValues(roomTypes, ratePlans)
                }).catch(() => {
                    this.setState({
                                      isLoading: false,
                                      showErrorModal: true,
                                      errorMessage: 'There was an error while reading rate plans data'
                                  })
                })
        }
    }

    async buildFormValues(roomTypes, ratePlans) {
        // Room types codes from RoomTypesService response
        let roomTypesCodes = roomTypes.map(roomType => roomType.hotelRoomTypeCode)
        // Build SRP inventory form values
        if (ratePlans && ratePlans.length > 0) {
            let srpInventory = []

            // TODO: Minimum value for SRP Inventory should be the original from RatePlan
            ratePlans.forEach(rateplan => {
                let inventory = {
                    ratePlanCode: rateplan.ratePlanCode || '',
                    ratePlanName: rateplan.ratePlanName || '',
                    inventory: rateplan.inventory || 0,
                    participating: rateplan.participating || false,
                    roomTypes: rateplan.roomTypes
                }

                // Set room types with checkboxes
                if (rateplan.roomTypes) {
                    inventory.roomTypes = roomTypesCodes.map(roomType => {
                        return {
                            code: roomType,
                            isChecked: rateplan.roomTypes.some(rt => rt.code === roomType || rt === roomType)
                        }
                    })
                } else {
                    // Default select all room types
                    inventory.roomTypes = roomTypesCodes.map(roomType => {
                        return {
                            code: roomType,
                            isChecked: true
                        }
                    })
                }

                srpInventory.push(inventory)
            })

            this.setState({
                              isLoading: false,
                              initialValues: {
                                  srpInventory: srpInventory
                              },
                              roomTypes: roomTypesCodes
                          })
        } else {
            this.setState({
                              isLoading: false,
                              roomTypes: roomTypesCodes,
                              initialValues: {
                                  srpInventory: []
                              }
                          })
        }
    }

    handleSubmit = (data) => {
        let putData = {
            hotelCode: this.state.hotelCode
        }

        const participatingSrpInventory = data.srpInventory.filter(inventory => inventory.participating)

        putData.srpInventories = participatingSrpInventory.map(inventory => {
            return {
                ratePlanCode: inventory.ratePlanCode,
                inventory: inventory.inventory,
                roomTypes: inventory.roomTypes
                    .filter(roomType => roomType.isChecked)
                    .map(roomType => ({ code: roomType.code }))
            }
        })

        this.props.onPut(putData)
        this.setState({ isLoading: true, loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({
                                  isLoading: false,
                                  showErrorModal: true,
                                  errorMessage: this.props.errorDescription
                              })
            } else {
                // Navigate to next page after successful save
                this.props.history.push(RouteConst.ROUTE_RATEPLANS_PAGE)
            }
        }
    }

    handleClearForm = () => {
        this.setState({ showResetModal: true })
    }

    resetFormData = (formikResetFormMethod) => {
        formikResetFormMethod()
        this.setState({
                          showResetModal: false
                      })
    }


    render() {
        return (
            <div className='srp-inventory-page'>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_HOME_PAGE}>Home</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_RATEPLANS_PAGE}>Rate Plans</NavLink></li>
                        <li className="breadcrumb-item active" aria-current="page">SRP Inventory</li>
                    </ol>
                </nav>

                <Formik
                    initialValues={this.state.initialValues}
                    validationSchema={this.validationSchema}
                    enableReinitialize={true}
                    onSubmit={(data, { setSubmitting }) => {
                        setSubmitting(true)
                        this.handleSubmit(data)
                        setSubmitting(false)
                    }}>
                    {
                        ({ values, isSubmitting, resetForm, errors, touched, submitCount }) => (
                            <>
                                <h5 className='d-block d-xl-none text-center mt-5'>{FormConst.PAGE_NOT_ACCESSIBLE_ON_DEVICE}</h5>
                                <div className='srp-inventory-form d-none d-xl-block'>
                                    <Form>
                                        <div id='srp-inventory-form-fields' className='srp-inventory-form-fields'>
                                            <p className='helper-text'>SRP Inventory</p>
                                            <p>This page is for rate plan inventories.</p>
                                            <p>Select the plans you want to use by checking the opt-in box.</p>
                                            <p>After opting in, specify the number of inventories and applicable room types for each chosen rate plan.</p>
                                            <table id='srp-inventory-table' className='table srp-inventory-table'>
                                                <thead>
                                                <tr>
                                                    <th>Opt In</th>
                                                    <th>Rate Plan Code</th>
                                                    <th>Rate Plan Name</th>
                                                    <th>Inventory</th>
                                                    <th>Room Types</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    isArrayNotEmpty(values.srpInventory)
                                                    ? values.srpInventory.map((rateplan, rateplanIndex) => {
                                                        let cellColorClass = rateplanIndex % 2 === 0 ? 'cell-dark' : 'cell-light'
                                                        const roomTypesPath = `srpInventory.${rateplanIndex}.roomTypes`
                                                        const roomTypesError = getIn(errors, roomTypesPath)
                                                        const roomTypesTouched = getIn(touched, roomTypesPath)
                                                        const showRoomTypesError = rateplan.participating
                                                            && roomTypesError
                                                            && (roomTypesTouched || submitCount > 0)
                                                        return (
                                                            <React.Fragment key={`rateplan-${rateplanIndex}`}>
                                                                <tr className={cellColorClass}>
                                                                    <td className='opt-in-cell'>
                                                                        <TextInput
                                                                            id={`opt-in-${rateplanIndex}`}
                                                                            type='checkbox'
                                                                            name={`srpInventory.${rateplanIndex}.participating`}
                                                                            value={rateplan.participating}
                                                                            checked={rateplan.participating}
                                                                        />
                                                                    </td>
                                                                    <td className='rateplan-code-cell'>{rateplan.ratePlanCode}</td>
                                                                    <td className='rateplan-name-cell'>{rateplan.ratePlanName}</td>
                                                                    <td className='inventory-cell'>
                                                                        <TextInput
                                                                            id={`inventory-${rateplanIndex}`}
                                                                            type='number'
                                                                            min='0'
                                                                            placeholder='0'
                                                                            name={`srpInventory.${rateplanIndex}.inventory`}
                                                                            disabled={!rateplan.participating}
                                                                            title='Inventory Amount'
                                                                        />
                                                                    </td>
                                                                    <td className='room-types-fields'>
                                                                                <span>
                                                                                    {rateplan.roomTypes && rateplan.roomTypes.map((roomType, roomTypeIndex) => {
                                                                                        return <TextInput
                                                                                            key={`room-type-${roomTypeIndex}`}
                                                                                            id={`room-type-${rateplanIndex}-${roomTypeIndex}`}
                                                                                            type='checkbox'
                                                                                            name={`srpInventory.${rateplanIndex}.roomTypes.${roomTypeIndex}.isChecked`}
                                                                                            value={roomType.isChecked}
                                                                                            checked={roomType.isChecked}
                                                                                            suffix={roomType.code}
                                                                                            disabled={!rateplan.participating}
                                                                                        />
                                                                                    })}
                                                                                </span>
                                                                                {showRoomTypesError && (
                                                                                    <div className='invalid'>{roomTypesError}</div>
                                                                                )}
                                                                    </td>
                                                                </tr>
                                                            </React.Fragment>
                                                        )
                                                    })
                                                    : (
                                                        <tr>
                                                            <td colSpan="5" className='text-center'>No SRP Inventory available</td>
                                                        </tr>
                                                    )
                                                }
                                                </tbody>
                                            </table>
                                            <FormFooter
                                                form={{
                                                    previous: { title: 'Box Inventory', route: RouteConst.ROUTE_BOX_INVENTORY_PAGE },
                                                    next: { title: 'Third Party Rate Programs', route: RouteConst.ROUTE_OTA_RATE_PROGRAMS_PAGE }
                                                }}
                                                isSubmit
                                                submitName={FormConst.SAVE_BUTTON_TEXT}
                                                resetName={FormConst.RESET_BUTTON_TEXT}
                                                onReset={this.handleClearForm}
                                                submitDisabled={isSubmitting} />
                                            <FormModal
                                                id='srp-inventory-page-save-modal'
                                                title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                                hotelInfo={this.state.hotelInfo}
                                                body={<h6>{this.state.loadingMessage}</h6>}
                                                show={this.state.isLoading}
                                                isLoadingIndicator />
                                            <FormModal
                                                id='srp-inventory-page-reset-modal'
                                                hotelInfo={this.state.hotelInfo}
                                                title={FormConst.MODAL_RESET_ACTION_TITLE}
                                                body={<h5>{FormConst.MODAL_RESET_ACTION_TEXT}</h5>}
                                                proceed={() => {
                                                    this.resetFormData(resetForm)
                                                }}
                                                cancel={() => { this.setState({ showResetModal: false }) }}
                                                show={this.state.showResetModal} />
                                            <FormModal
                                                id='srp-inventory-page-error-modal'
                                                hotelInfo={this.state.hotelInfo}
                                                title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                                body={<h5>{this.state.errorMessage}</h5>}
                                                isError
                                                cancel={() => { this.setState({ showErrorModal: false }) }}
                                                show={this.state.showErrorModal} />
                                        </div>
                                    </Form>
                                </div>
                            </>
                        )
                    }
                </Formik>
            </div>
        )
    }
}

// Redux mapping
const mapStateToProps = state => {
    return {
        srpInventoryResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGet: (hotelCode) => dispatch(asyncMethod(FormConst.FORM_SRP_INVENTORY_NAME, actionTypes.ASYNC_ACTIONS.GET, { hotelCode: hotelCode })),
        onPut: (data) => dispatch(asyncMethod(FormConst.FORM_SRP_INVENTORY_NAME, actionTypes.ASYNC_ACTIONS.PUT, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(SRPInventory, SideNavEntryMapping.RATE_PLANS))